import React from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#F0F4FF]" aria-labelledby="pricing-heading" data-id="element-187">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-188">
        <h2 id="pricing-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-189">
          Pricing
        </h2>
        <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full mb-12" aria-hidden="true" data-id="element-190"></div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-191">
          {/* Decorative element */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#4AA6CF]/10 rounded-bl-full -z-0" aria-hidden="true" data-id="element-192"></div>

          <div className="relative z-10" data-id="element-193">
            <span className="inline-block px-4 py-1.5 bg-[#E7ECF8] text-[#1E1F55] font-semibold rounded-full text-sm mb-6" data-id="element-194">
              All-Inclusive Pricing
            </span>

            <div className="flex justify-center items-baseline mb-6" data-id="element-195">
              <span className="text-6xl md:text-7xl font-extrabold text-[#1E1F55] tracking-tight" data-id="element-196">
                $62.25
              </span>
            </div>

            <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-197">
              We charge a flat fee for all background checks and fingerprinting
              services, including all CJIS / government fees.
            </p>

            <a href="#/booking" className="inline-block bg-[#1E1F55] text-white hover:bg-[#2A2C6B] px-10 py-4 rounded-full text-lg font-bold transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5" data-id="element-198">
              Book Appointment Now
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}